import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import Modal from '@/components/modal/modal-component';
import processOptionData from '@/pages/company-management/company-options/options-utils';
import FormWrapper from '@/components/form-wrapper/form-wrapper-component';
import Loader from '@/components/loader/loader-component';
import ProductOptionVariantForm from './product-option-variant-form';
import Styled from './product-options-style';

/**
 * Item component for displaying an option menu.
 * @param {object} props - The props passed to the OptionMenu component.
 * @param {object | bool} props.isOpen - Hide or show modal.
 * @param {Function} props.setIsOpen - Set modal state.
 * @param {Function} props.onSubmit - Handle form submission.
 * @param {boolean} props.loading - Loading state.
 * @returns {JSX.Element} The rendered Item component.
 */
const ProductOptionVariantModal = ({
  isOpen,
  setIsOpen,
  onSubmit,
  loading,
}) => {
  const { id: companyId } = useParams();

  const optionId = isOpen?.values?.option_id;

  return (
    <Modal
      open={isOpen}
      showClose
      title="Add Option Variant"
      close={() => setIsOpen(false)}
      width="90%"
      bodyStyle={{
        padding: '0px',
      }}
    >
      <FormWrapper
        defaultValues={async () =>
          processOptionData(companyId, optionId, {
            isEdit: true,
          })
        }
      >
        {loading ? (
          <Loader loading $height="400px" />
        ) : (
          <Styled.ModalContentWrapper>
            <ProductOptionVariantForm
              optionId={optionId}
              submitForm={onSubmit}
              closeModal={() => setIsOpen(false)}
            />
          </Styled.ModalContentWrapper>
        )}
      </FormWrapper>
    </Modal>
  );
};

ProductOptionVariantModal.defaultProps = {
  isOpen: false,
};

ProductOptionVariantModal.propTypes = {
  isOpen: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  setIsOpen: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default ProductOptionVariantModal;
